var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFilter(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 15,
    viewBox: "0 0 18 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.38 1.13602C17.38 1.76337 16.8134 2.27204 16.1141 2.27204H1.26588C0.566817 2.27204 0 1.76356 0 1.13602C0 0.508672 0.566607 0 1.26588 0H16.1143C16.8134 0 17.38 0.508672 17.38 1.13602Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.3957 7.14652C14.3957 7.77387 13.8618 8.28254 13.2029 8.28254H3.17378C2.51506 8.28254 1.98096 7.77406 1.98096 7.14652C1.98096 6.51917 2.51486 6.0105 3.17378 6.0105H13.2031C13.8618 6.0105 14.3957 6.51917 14.3957 7.14652Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4241 13.1568C11.4241 13.7841 10.8902 14.2928 10.2313 14.2928H6.14546C5.48674 14.2928 4.95264 13.7843 4.95264 13.1568C4.95264 12.5294 5.48654 12.0208 6.14546 12.0208H10.2315C10.8902 12.0208 11.4241 12.5294 11.4241 13.1568Z",
    fill: "#000000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFilter);
export default __webpack_public_path__ + "static/media/icon-filter.52b059fb.svg";
export { ForwardRef as ReactComponent };